/**
 * Api documentation
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface ExportPlansRequestDTO { 
    clientId: number;
    brandId: number;
    conversionType: string;
    dateStart: string;
    dateStop: string;
    viewType: string;
    tableDimension?: ExportPlansRequestDTO.TableDimensionEnum;
    planIds: Array<number>;
}
export namespace ExportPlansRequestDTO {
    export type TableDimensionEnum = 'channel' | 'segment' | 'tactic';
    export const TableDimensionEnum = {
        Channel: 'channel' as TableDimensionEnum,
        Segment: 'segment' as TableDimensionEnum,
        Tactic: 'tactic' as TableDimensionEnum
    };
}


